import React from 'react'
import Layout from '../Components/Layouts/Layout'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import TtyIcon from '@mui/icons-material/Tty';
const Contact = () => {
  return (
    <Layout>
      <Box sx={{my:10, ml:10, "& h4":{fontWeight: 'bold',mb:2}}}>
         <Typography variant='h4'>
             Contact My Resturant.
         </Typography>
         <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe tempore a aut ipsum omnis veritatis culpa animi, temporibus architecto illo ad sit aliquid! Quam nisi quae aut doloremque in itaque.</p>
      </Box>
       <Box sx={{m:3, width:'600px',ml:10,"@media (max-width:600px)":{
         width:'300px',
         ml:10,
       }}}>
        <TableContainer component={Paper}>
            <Table aria-lable="contact Table">
               <TableHead>
                  <TableRow>
                    <TableCell sx={{backgroundColor:'black',color:'white',textAlign:'center'}}>
                      Contact Deatils
                    </TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  <TableRow>
                    <TableCell><SupportAgentIcon sx={{color:'red',pt:1}} /> 123456798 (TollFree).</TableCell>

                  </TableRow>
                  <TableRow> <TableCell><MarkEmailReadIcon sx={{color:'blue',pt:1}} /> help@gmail.com.</TableCell></TableRow>
                  <TableRow> <TableCell><TtyIcon sx={{color:'green',pt:1}} /> help@gmail.com.</TableCell></TableRow>
               </TableBody>
            </Table>
        </TableContainer>
       </Box>
    </Layout>
  )
}

export default Contact
